<template>
  <v-main id="container" ref="container" class="pa-4">
    <div v-if="form">
      <v-form ref="form">
        <section>
          <v-subheader class="pl-0">日期與時間</v-subheader>
          <p class="text-body-2 primary--text">請先選日期，再選擇預約時段</p>
          <v-select
              v-model="fields.date"
              :items="dates"
              label="選擇日期"
              :rules="rules.dates"
              noDataText="本月尚未開放"
              solo
          ></v-select>
          <!-- v-select @change="dateChange"  -->
          <v-select
            v-model="fields.time"
            :items="times.map(time => time.name)"
            label="選擇時段"
            :rules="rules.times"
            noDataText="本月尚未開放"
            solo
            @change="timeChange"
          ></v-select>
          <v-alert v-if="isCandidate" type="error">
            目前該時段預約已滿，送出本表單是預約候補名額，可以接受再行報名喔！
          </v-alert>
          <v-alert v-else-if="isFull" type="error">
            目前正取與候補名額皆已額滿囉
          </v-alert>
        </section>
        <section>
          <v-subheader class="pl-0">基本資料</v-subheader>
          <v-text-field
            v-model="fields.name"
            label="姓名"
            :rules="rules.name"
            single-line
            solo
            required
          ></v-text-field>
          <v-text-field
            v-model="fields.dept"
            label="系別(若為外校生 請額外輸入校名)"
            :rules="rules.dept"
            single-line
            solo
            required
          ></v-text-field>
          <v-text-field
            v-model="fields.phone"
            label="手機"
            :rules="rules.phone"
            single-line
            solo
            required
          ></v-text-field>
          <v-text-field
            v-model="fields.email"
            label="電子信箱"
            :rules="rules.email"
            single-line
            solo
            required
          ></v-text-field>
          <v-radio-group v-model="fields.role" mandatory row>
            <v-radio label="本校碩士生" value="nctu-master"></v-radio>
            <v-radio label="本校博士生" value="nctu-phd"></v-radio>
            <v-radio label="外校生" value="others"></v-radio>
          </v-radio-group>
        </section>
        <section>
          <v-subheader class="pl-0 mt-6 d-block">
            <div>請在底下勾選您想要晤談的主題（可複選）</div>
            <v-input :rules="[v => isThemesValid || '至少要選擇一個主題喔！']"></v-input>
          </v-subheader>
          <v-row no-gutters>
            <template v-for="theme in form.themes">
              <v-col cols="6" lg="6" :key="theme.name">
                <v-checkbox v-model="fields.themes" :label="theme.name" :value="theme.name"></v-checkbox>
              </v-col>
            </template>
              <v-col cols="12">
                <checkboxInput v-model="fields.themes" ref="checkboxInput"/>
              </v-col>
          </v-row>
        </section>
        <section>
          <v-subheader class="pl-0 mt-6 d-block">
            <div>底下是後續可能會使用到的職涯評估工具，請勾選您感興趣的項目（可複選）</div>
            <v-input :rules="[v => isToolsValid || '至少要選擇一個工具喔！']"></v-input>
          </v-subheader>
          <v-row no-gutters>
            <template v-for="tool in form.tools">
              <v-col cols="6" lg="6" :key="tool.name">
                <v-checkbox v-model="fields.tools" :label="tool.name" :value="tool.name"></v-checkbox>
              </v-col>
            </template>
          </v-row>
        </section>
        <v-btn @click="submit" color="primary" :disabled="isFull" large block>送出</v-btn>
      </v-form>
    </div>
    <div v-else>
      <v-alert type="error">表單ID不對喔，找不到這個表單🥺</v-alert>
    </div>
  </v-main>
</template>
<script>
import CheckboxInput from '@/components/CheckboxInput.vue'
import { mapMutations } from 'vuex'
import { db, addBooking } from '@/firebase'
import { firstDayOfThisMonth } from '@/utils'
// import { firstDayOfThisMonth, lastDayOfThisMonth } from '@/utils'

export default {
  name: 'Form',
  data: () => ({
    formId: '',
    form: {
      datetime: [],
      themes: [],
      tools: []
    },
    candidates: 0,
    fields: {
      date: '',
      time: '',
      name: '',
      dept: '',
      phone: '',
      email: '',
      role: '',
      themes: [],
      tools: []
    },
    rules: {
      dates: [v => !!v || '請選擇日期'],
      times: [v => !!v || '請選擇時段'],
      name: [v => !!v || '請填寫姓名'],
      dept: [v => !!v || '請填寫系級'],
      phone: [
        v => !!v || '請填寫手機',
        v => /^09[0-9]{8}$/.test(v) || '手機格式錯誤'
      ],
      email: [
        v => !!v || '請填寫email',
        v => /.+@.+\..+/.test(v) || 'email格式錯誤'
      ]
      // themes: [v => isThemesValid || '至少要選擇一個主題喔！'],
      // tools: [v => isToolsValid || '至少要選擇一個工具喔！']
    },
    bookings: []
  }),
  created () {
    this.formId = this.$route.params.id
    if (this.formId === '') {
      alert('網址錯誤，表單ID不可為空')
      return
    }
    this.startLoading()
    // using vuexfire bind local data
    this.$bind('form', db.collection('forms').doc(this.formId)).then(form => {
      // form will point to the same property declared in data: this.form === form
      if (form) {
        this.selectDefault()
        // console.log(document.querySelector('#container').offsetHeight)
        // 讓parent能夠設定iframe的高度
        // window.parent.postMessage({
        //   type: 'mentor-booking-form-height',
        //   height: document.querySelector('#container').offsetHeight
        // }, 'https://startuplab.nctu.edu.tw')
      }
      this.closeDialog()
    })
  },
  methods: {
    ...mapMutations({
      showDialog: 'SHOW_DIALOG',
      startLoading: 'START_LOADING',
      closeDialog: 'CLOSE_DIALOG'
    }),
    dateChange () {
      if (!this.form || this.form.datetime.length === 0) return
      const time = this.form.datetime.find((item) => item.date === this.fields.date).times[0]
      this.fields.time = time.name
      this.candidates = time.candidates
      this.dateTimeChange()
    },
    timeChange (val) {
      const times = this.form.datetime.find((item) => item.date === this.fields.date).times
      this.candidates = times.find((time) => time.name === this.fields.time).candidates
      this.dateTimeChange()
    },
    dateTimeChange () {
      if (this.formId === '' || this.fields.date === '' || this.fields.time === '') return
      // this.startLoading()
      const sameDateTimeBookingsRef = db.collection('bookings').where('formId', '==', this.formId).where('date', '==', this.fields.date).where('time', '==', this.fields.time)
      this.$bind('bookings', sameDateTimeBookingsRef).then(bookings => {
        // this.closeDialog()
      })
    },
    selectDefault () {
      // 由於產運反應說，使用者都以為只有一個時段可以選，於是就把自動選擇預設值得功能關掉了
      // if (this.dates.length === 0) return
      // this.fields.date = this.dates[0]
      // this.dateChange()
    },
    async submit () {
      const isValid = this.$refs.form.validate()
      if (!isValid) return
      this.startLoading()
      try {
        await addBooking({
          formId: this.formId,
          form: this.form,
          isCandidate: this.isCandidate,
          ...this.fields
        })
        this.resetForm()
        this.showDialog({
          title: '預約成功！',
          content: '恭喜你預約成功，去信箱收個信吧！'
        })
      } catch (error) {
        this.showDialog({
          title: '尷尬，出事了...',
          content: `錯誤訊息: ${error.message}`
        })
      }
    },
    resetForm () {
      this.$refs.form.resetValidation()
      this.fields = this.$options.data().fields
      this.$refs.checkboxInput.reset()
      this.selectDefault()
    }
  },
  computed: {
    dates () {
      if (!this.form) return []
      const dayLowerLimit = firstDayOfThisMonth()
      // const dayUpperLimit = lastDayOfThisMonth()
      // 僅開放這個月
      // return this.form.datetime.filter((item) => item.date >= dayLowerLimit && item.date <= dayUpperLimit).map((item) => item.date)
      // 開放這個月以後所有
      return this.form.datetime.filter((item) => item.date >= dayLowerLimit).map((item) => item.date)
    },
    times () {
      if (!this.form) return []
      const item = this.form.datetime.find((item) => item.date === this.fields.date)
      return item ? item.times : []
    },
    isCandidate () {
      // 要有dates > 0 的條件，代表有可選的資料，不然沒有資料的話，也會被視為正取額滿
      // 由於產運反應說，使用者都以為只有一個時段可以選，於是就把自動選擇預設值(selectDefault)得功能關掉了
      // 因為selectDefault目前關掉了，所以fields.data & fields.time都必須有內容，才能夠進行後續的判斷
      return this.fields.date !== '' && this.fields.time !== '' && this.dates.length > 0 && this.bookings.length >= 1 && this.bookings.length < this.candidates
    },
    isFull () {
      // 要有dates > 0 的條件，代表有可選的資料，不然沒有資料的話，也會被視為正取和候補都額滿
      // 由於產運反應說，使用者都以為只有一個時段可以選，於是就把自動選擇預設值(selectDefault)得功能關掉了
      // 因為selectDefault目前關掉了，所以fields.data & fields.time都必須有內容，才能夠進行後續的判斷
      return this.fields.date !== '' && this.fields.time !== '' && this.dates.length > 0 && this.bookings.length >= this.candidates
    },
    isThemesValid () {
      return this.fields.themes.length > 0
    },
    isToolsValid () {
      return this.fields.tools.length > 0
    }
  },
  components: {
    CheckboxInput
  }
}
</script>
<style lang="scss" scoped>
#container {
  max-width: 550px;
  margin: auto;
}
</style>
